import React from 'react';
import BlogPost from "../BlogPost";

const TwoStorytellers = () => {
    return (
    <BlogPost
        id="TheTwoStorytellers"
        title="The Two Storytellers"
        content={
            <>
                &quot;Please, if you would be so kind, explain how this works one more time for me
                my good Zade?&quot; a middle-aged woman listens to the request as she plucks two
                books from a shelf and elegantly saunters to the couch. Plopping down across from
                her guest, she adjusts the layers of her long skirt, placing the two leather-bound
                works in front of him. &quot;Call me Shehera if you wouldn't mind,&quot; she says as
                she looks up at the guest and winks &quot;or Aunty Essem if you want a good
                time.&quot; Datris leans back a little farther in his chair and raises an eyebrow
                before shifting forward again, elbows on knees, a hand, palm turned down under his
                chin, and retorts with a conspiritorial smirk &quot;fine then. Shehera it is. I
                might be a fool, but I'm not foolhardy enough to walk straight into one of your
                little stories.&quot; Datrius runs the fingers of his free hand across the text
                embossed in the two works that have been placed in front of him. &quot;Two copies of
                the same book? Why would I need to read the same thing&quot; his eyes widen and,
                interrupting the audible thought, he pulls back like a child touching a hot
                stove &quot;which is it?&quot;
                <br/><br/>
                Shehera giggles &quot;oh, don’t worry, just touching the book does nothing at all.
                It’s the act of reading that engages my art. It would be far less satisfying of an
                effect otherwise. After all, it’s the fabulous story telling, the infectious
                diction, the way it draws forth something innate from one’s soul. That’s what leads
                to the magnificent outcomes after all.&quot;
                <br/><br/>
                &quot;Or you’ve figured out how to weave the most complex geas Val’aran, Janis, even
                Akelar has ever seen. For Æ’s sake it doesn't even register as magic!&quot; Shehera
                looks Datrius up and down. Raising his arms to the sky, he exclaims the Al'Elements
                name and holds the pose to emphasize his exasperation. With another chuckle she
                calmly answers, &quot;I did tell you. It isn't magic. Just great writing. See this
                book. Of the hundreds I crafted Cruel Souls only produced two copies that affect the
                reader, to my knowledge at least. They do have the same effect, but truly I don't
                know how or why. I may be able to tell when it happens, but why still alludes
                me.&quot;
                <br/><br/>
                &quot;Perfect. Then you can just stop releasing them couldn't you or destroy those
                copies?&quot; Datrius ponders standing and beginning to pace the small cabin. A weak
                attempt to put distance between himself and the book. He takes a moment, waiting for
                Shehera’s response, to appreciate the beauty of her home. The walls of the main room
                were almost entirely bookshelves carved of gorgeous lumber she must have had brought
                in. The collection on them was its own sight to behold, including many rare titles
                as well as a suspicious number of copies of Shehera’s own works which, Datrius now
                surmised must be those copies. Making a note to ask her another time about how the
                rest of the collection, and private island for that matter, came into her
                possession.
                <br/><br/>
                &quot;It just wouldn't be right to deny the world my greatest works&quot; she
                exclaims following behind Datrius and laying her hand on his shoulder and leaning in
                to whisper &quot;I can’t destroy them. The magic hops when you do.&quot;
                <br/><br/>
                What do you mean it hops? What if you destroy the last one?&quot; Datrius turns,
                grabbing her, and stares into her eyes, attempting however futilely to determine if
                this is the truth or another game. Seeing the concern in his face, she takes a
                breath and replies &quot;it does. Another copy becomes the enchanted one. As for
                destroying the last, I tried. It would burn like any book and then reappear
                somewhere. These books are something special, Datrius. I don’t know what else to
                tell you. I can’t stop writing. It’s who I am. You should understand as a
                storyteller yourself.&quot;
                <br/><br/>
                He looks away and begrudgingly nods.
                <br/><br/>
                &quot;I’m glad you can understand what I mean. Few can fully comprehend what it
                means to be so divinely compelled to author such tales. This isn’t just me. There’s
                something at work here I don’t understand, like that mist that tends to entrap the
                island.&quot;
                <br/><br/>
                &quot;I have been meaning to ask about that. Has the mist always been&quot; Datrius
                stumbles for a moment, taking a beat, and returning &quot;yes, I understand
                Shehera&quot; he leads them back to the couch sitting with her this time. The two
                look down at the book. The title: The Girl’s Monster staring back at them. &quot;I
                do have to ask, what does this one do?&quot;
                <br/><br/>
                Lackadaisical Shehera replies &quot;oh, nothing much. I think it just compels one to
                seek out a rush from a dangerous situation.&quot; She watches Datrius place his face
                in his hands, and slowly shake his head, letting out a massive sigh.
                <br/><br/>
                &quot;By Æ and the Origins. I pray for whoever finds one of these. How many
                enchanted copies are there?&quot;
                <br/><br/>
                &quot;Oh, just one!&quot;
                <br/><br/>
                Great news then, Datrius begins to think, if there’s one, and it’s here, no harm or
                fowl, but Shehera cuts his thought off stating &quot;only thing is, neither of these
                are actually it. I was just playing with you earlier.&quot;<br/><br/>&quot;By the
                blessed Al’Element we are doomed.&quot;
            </>
        }
        photoSrc=""
        photoAlt=""
        noteText="Ugh, not another one of these books. Don't know why but never found a single one very interesting. - Nero Nightsbane"
    />
    );
};

export default TwoStorytellers;
